<!-- @format -->

<div class="dialog-max cdialog" style="width: 40vw; max-height: 80vh">
  <div class="dialogHeader">
    <div mat-dialog-title>{{ _common.BookingDetails }}</div>
    <div
      class="app-btn btn-outline actionButton"
      [matMenuTriggerFor]="actionMenu"
      style="margin-right: 2rem"
    >
      <div>{{ _common.actions }}</div>
      <fa-icon icon="caret-down"></fa-icon>
    </div>
    <div (click)="cancel()" class="closeButton">
      <fa-icon icon="times"></fa-icon>
    </div>
  </div>

  <mat-dialog-content class="max-height">
    <div class="max-scroll dialogBody" *ngIf="object">
      <ng-container
        *ngIf="
          object.status == statusList.pending && now.isBefore(object.endTime)
        "
      >
        <div class="card">
          <div class="cardBody flex items-center">
            <div class="flex-auto">{{ _common.booking_approval }}</div>
            <div
              class="flex gap-2"
              *ngIf="
                locationAllowed &&
                session.hasPermission(permissions.BOOKING_APPROVE)
              "
            >
              <button class="app-btn btn-outline" (click)="reject()">
                <fa-icon
                  icon="circle-xmark"
                  style="margin-right: 5px; color: red"
                ></fa-icon>
                {{ _common.reject }}
              </button>
              <button class="app-btn btn-outline" (click)="approve()">
                <fa-icon
                  icon="circle-check"
                  style="margin-right: 5px; color: #409e4c"
                ></fa-icon
                >{{ _common.approve }}
              </button>
            </div>
          </div>
        </div>
      </ng-container>

      <div class="card">
        <div class="cardBody">
          <div class="flex items-center">
            <div class="text-xs spacer" style="color: #707070">
              {{ object.bookingNo }}
            </div>
            <div>
              {{ _common.usage_theme }}: {{ object.purpose?.name }}
              <!-- <button
                class="text-link link-blue"
                (click)="selectPurpose()"
                *ngIf="session.hasPermission(permissions.BOOKING_EDIT)"
              >
                ({{ _common.change }})
              </button> -->
            </div>
          </div>

          <div class="mb-4">
            <div class="spacer">
              <div *ngIf="object.space; let space" class="text-xl font-bold">
                {{ lang(space.name, space.name_lang) }}
              </div>
              <ng-container *ngIf="object.space.location; let location">
                <div class="text-xs">
                  <ng-container
                    *ngIf="$any(location).organization; let organization"
                  >
                    {{ lang(organization.name, organization.name_lang) }}
                    {{ lang(location.name, location.name_lang) }}
                  </ng-container>
                </div>
              </ng-container>
            </div>
          </div>

          <div class="app-chip Status mb-2" [ngClass]="object.status">
            {{ _common.bookingStatus[object.status] }}
          </div>

          <div *ngIf="object.status == statusList.cancelled">
            <div style="background: #eee; border-radius: 5px" class="p-2 mb-2">
              <ng-container *ngIf="!object.cancelMember?.name">
                <div class="text-xs flex items-center" style="color: #707070">
                  <fa-icon
                    icon="square-xmark"
                    style="margin-right: 5px"
                  ></fa-icon>
                  {{ _common.cancel_booking_reason.other_reason }}
                </div>
                <div>
                  {{ _common.cancel_booking_reason[object.cancelReasonCode] }}
                  <span *ngIf="object.cancelReason">
                    : {{ object.cancelReason }}
                  </span>
                </div>
              </ng-container>

              <ng-container *ngIf="object.cancelMember?.name">
                {{ _common.cancel_booking_byStaff }} ({{
                  object.cancelMember?.name
                }})
              </ng-container>
              <div *ngIf="object.cancelDate" class="text-xs text-gray-500">
                {{ formatTime(object.cancelDate) }}
              </div>

              <ng-container *ngIf="object.rejectMember?.name">
                Rejected By ({{ object.rejectMember?.name }})
              </ng-container>
              <div *ngIf="object.rejectDate" class="text-xs text-gray-500">
                {{ formatTime(object.rejectDate) }}
              </div>
              <ng-container *ngIf="object.approveUser?.name">
                Approved By ({{ object.approveUser?.name }})
              </ng-container>
              <div
                *ngIf="object.approveDate && !object.cancelDate"
                class="text-xs text-gray-500"
              >
                {{ formatTime(object.approveDate) }}
              </div>
            </div>
          </div>

          <div style="display: grid; grid-template-columns: 25px 1fr">
            <div class="text-center">
              <fa-icon icon="calendar-days"></fa-icon>
            </div>
            <div>
              {{ dateText(object) }}
            </div>
            <div class="text-center">
              <fa-icon icon="clock"></fa-icon>
            </div>
            <div>
              {{ timeText(object, _common) }}
            </div>
            <div class="text-center">
              <fa-icon icon="user"></fa-icon>
            </div>
            <div>{{ object.member?.name }} {{ object.user?.name }}</div>
            <div class="text-center">
              <fa-icon icon="envelope"></fa-icon>
            </div>
            <div>{{ object.member?.email }}</div>
            <div class="text-center">
              <fa-icon icon="phone-flip"></fa-icon>
            </div>
            <div>{{ object.member?.mobile }}</div>
            <ng-container *ngIf="object.locker; let locker">
              <div>{{ _common.Locker }}</div>
              <div>
                <div>
                  {{ locker.name }}
                </div>
                <div>
                  {{ object.lockerCell?.name }}
                </div>
              </div>
            </ng-container>
          </div>
        </div>
        <div
          *ngIf="object.contactName && object.contactName != ''"
          class="cardBody"
        >
          <div class="underline">
            {{ _common.ContactPerson }}
          </div>
          <div style="display: grid; grid-template-columns: 25px 1fr">
            <div class="text-center">
              <fa-icon icon="user"></fa-icon>
            </div>
            <div>{{ object.contactName }}</div>
            <div class="text-center">
              <fa-icon icon="envelope"></fa-icon>
            </div>
            <div>{{ object.contactEmail }}</div>
            <div class="text-center">
              <fa-icon icon="phone-flip"></fa-icon>
            </div>
            <div>{{ object.contactMobile }}</div>
          </div>
        </div>

        <!-- <div class="cardDivider"></div> -->
        <div class="cardBody">
          <div class="underline">
            {{ _common.AdditionalFacilities }}
          </div>
          <ng-container *ngIf="!object.facilities?.length"> N/A </ng-container>
          <div *ngFor="let f of object.facilities" class="flex flex-wrap">
            {{ lang(f.name, f.name_lang) }}
            <span class="client_chip ml-1" [ngClass]="f.fee">
              {{ _common.Facility[f.fee] }}
              <span *ngIf="f.fee == fees.custom">$&nbsp;{{ f.feeText }}</span>
            </span>
          </div>
        </div>

        <!-- <div class="cardDivider"></div> -->
        <div class="cardBody">
          <div class="underline">{{ _common.Remarks }}</div>
          <div *ngIf="object.remarks && object.remarks != ''">
            {{ object.remarks }}
          </div>
          <div *ngIf="!object.remarks || object.remarks == ''">N/A</div>
        </div>
      </div>

      <!--////Participant List////-->
      <div class="card">
        <div class="cardHeader">
          {{ _common.numParticipants_list }}
          <ng-container
            *ngIf="object.space.capacity > 1 || !object.space.capacity"
          >
            <span style="font-weight: normal">
              ({{ participants.length }}/{{ object.numParticipants }})</span
            >
          </ng-container>
        </div>
        <div class="cardBody">
          <ng-container
            *ngIf="object.space.capacity == 1 && object.space.maxBookings <= 1"
          >
            <div class="text-gray-500">
              {{ _common.numParticipants_list_na_capacity }}
            </div>
          </ng-container>
          <ng-container *ngIf="object.space.maxBookings > 1">
            <div class="text-gray-500">
              {{ _common.numParticipants_list_na_maxBookings }}
            </div>
          </ng-container>
          <div *ngFor="let p of participants">
            {{ p.member.name }} [{{ formatTime(p.log?.time) }}]
          </div>
        </div>
      </div>
      <div class="card">
        <div class="cardHeader">
          <div class="flex-auto">
            <span>{{ _common.walkin_list }}</span>
            <span style="font-weight: normal"> ({{ walkins.length }}) </span>
          </div>
        </div>
        <div class="cardBody">
          <ng-container
            *ngIf="object.space.capacity == 1 && object.space.maxBookings <= 1"
          >
            <div class="text-gray-500">
              {{ _common.walkin_list_na_capacity }}
            </div>
          </ng-container>
          <ng-container *ngIf="object.space.maxBookings > 1">
            <div class="text-gray-500">
              {{ _common.walkin_list_na_maxBookings }}
            </div>
          </ng-container>
          <div *ngFor="let p of walkins">
            {{ p.member?.name }} [{{ formatTime(p.log?.time) }}]
          </div>
        </div>
      </div>

      <div *ngIf="object" class="card">
        <div class="cardHeader">{{ _common.checkin_log }}</div>
        <div class="cardBody">
          <div *ngIf="!object.checkinLogs.length">N/A</div>
          <div *ngFor="let l of object.checkinLogs">
            <div>
              {{ formatTime(l.time) }}
              {{ l.member?.name }}
              <span class="text-gray-500">{{ l.deviceName }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-dialog-content>
  <!-- <div class="dialogBar">
    <button class="app-btn btn-outline" (click)="remove()" *ngIf="objectId">
      <fa-icon icon="trash" style="margin-right: 5px"></fa-icon
      >{{ _common.delete }}
    </button>
    <button class="app-btn btn-outline" (click)="sync()" *ngIf="objectId">
      <fa-icon icon="sync" style="margin-right: 5px"></fa-icon
      >{{ _common.Sync }}
    </button>
    <button class="app-btn btn-outline" (click)="webhook()" *ngIf="objectId">
      <fa-icon icon="sync" style="margin-right: 5px"></fa-icon>Webhook
    </button>

    <ng-container *ngIf="object">
      <ng-container
        *ngIf="
          object.status != statusList.cancelled &&
          now.isBefore(object.startTime)
        "
      >
        <button
          class="app-btn btn-outline"
          (click)="cancelBooking()"
          *ngIf="
            locationAllowed && session.hasPermission(permissions.BOOKING_CANCEL)
          "
        >
          {{_common.cancel_booking}}
        </button>
      </ng-container>
    </ng-container>
    <div class="spacer"></div>
  </div> -->
</div>

<mat-menu #actionMenu="matMenu">
  <ng-container *ngIf="object">
    <ng-container
      *ngIf="
        object.status != statusList.cancelled && now.isBefore(object.startTime)
      "
    >
      <button
        mat-menu-item
        (click)="cancelBooking()"
        *ngIf="
          locationAllowed && session.hasPermission(permissions.BOOKING_CANCEL)
        "
      >
        <fa-icon icon="calendar-xmark" style="margin-right: 5px"></fa-icon>
        {{ _common.cancel_booking }}
      </button>
    </ng-container>
  </ng-container>

  <button
    mat-menu-item
    (click)="sync()"
    *ngIf="objectId"
    style="border-top: 1px solid #eee"
  >
    <fa-icon icon="sync" style="margin-right: 5px"></fa-icon>{{ _common.Sync }}
  </button>
  <ng-container *ngIf="debug">
    <div
      class="text-xs"
      style="padding: 10px; color: #707070; border-top: 1px solid #eee"
    >
      For Testing Only (UAT)
    </div>
    <button mat-menu-item (click)="webhook()" *ngIf="objectId">
      <fa-icon icon="sync" style="margin-right: 5px"></fa-icon
      >{{ _common.sync_to_VP }}
    </button>
    <button mat-menu-item (click)="remove()">
      <fa-icon icon="trash" style="margin-right: 5px"></fa-icon
      >{{ _common.delete }}
    </button>
  </ng-container>
</mat-menu>
